export default {
  PAYPAL: Symbol('PAYPAL'),
};
